interface ValidationResult {
  isValid: boolean;
  error: string | null;
}

export const validatePhoneNumber = (phone: string): ValidationResult => {
  // Supprime tous les caractères non numériques sauf + pour la validation
  const cleanPhone = phone.replace(/[^\d+]/g, '');

  // Vérifie si le numéro commence par un + et contient entre 10 et 15 chiffres
  const isValidFormat = /^\+?\d{10,15}$/.test(cleanPhone);

  // Vérifie si c'est un numéro français (commence par +33 ou 0)
  const isFrenchNumber = /^(?:\+33|0)\d{9}$/.test(cleanPhone);

  if (!isValidFormat) {
    return {
      isValid: false,
      error: 'Le numéro doit contenir entre 10 et 15 chiffres'
    };
  }

  return {
    isValid: true,
    error: null
  };
};